<template>
  <div class="coach-login">
    <nav-bar
      fixed
      z-index="99"
      title="登录"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>
    <div class="register-title">教练登录</div>
    <form class="register-form" @submit.prevent="submit">
      <div>
        <div class="register-form-name"><span>*</span>手机号</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <input class="w-f" placeholder="请输入手机号" v-model="username" />
        </div>
        <div class="register-form-name"><span>*</span>密码</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <!-- <input
            type="password"
            style="width: 3rem"
            placeholder="请输入密码"
            v-model="password"
          /> -->
          <NfInput
            borderInnerSize="0"
            borderSize="0"
            padding="0"
            round=".5rem"
            :value.sync="password"
            placeholder="请输入密码"
            type="password"
          />
        </div>
        <div style="font-size: 0.23rem; margin-top: 0.6rem; color: #999999">
          <Checkbox shape="square" v-model="agree" checked-color="#0ce6df">
            我已阅读并同意
            <router-link :to="'/view_detail/41'" style="color: #0ce6df"
              >《用户协议》</router-link
            >
            和
            <router-link :to="'/view_detail/49'" style="color: #0ce6df"
              >《隐私政策》</router-link
            >
          </Checkbox>
        </div>
        <div class="btn" style="margin-top: 0.4rem" @click="submit">
          登录账号
        </div>
      </div>
      <div class="forget" @click="$router.push('/forget')">
        忘记密码？<span style="color: #0ce6df">找回密码</span>
      </div>
      <div class="padding-height"></div>
      <div class="bottom">
        <div class="btn" @click="showDialog = true">教练入驻</div>
      </div>
    </form>
    <Popup v-model="showDialog" round>
      <div class="agree-title">{{ articleInfo.title }}</div>
      <div class="agree-content">
        <div v-html="articleInfo.content"></div>
      </div>
      <div class="agree-btn" @click="dialogAction(true)">确认</div>
    </Popup>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { login } from "@api/user";
import attrs, { required, alpha_num } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";
import { Checkbox, NavBar, Popup } from "vant";
import { getViewDetails } from "@api/public";
import NfInput from "@/components/game-ui/NfInput.vue";
const BACK_URL = "login_back_url";

export default {
  name: "CoachLogin",
  components: { Checkbox, NavBar, Popup, NfInput },
  mixins: [sendVerifyCode],
  data: function () {
    return {
      username: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      codeText: "获取验证码",
      agree: false,
      showDialog: false,
      articleInfo: {},
    };
  },
  created() {
    this.getAgree();
  },
  methods: {
    getAgree: function () {
      getViewDetails(50).then((res) => {
        this.articleInfo = res.data;
      });
    },
    dialogAction() {
      this.showDialog = false;
      this.$router.push("/settle_in");
    },
    async submit() {
      const { username, password } = this;
      try {
        await this.$validator({
          username: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号")),
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码")),
          ],
        }).validate({ username, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (!this.agree) {
        this.$dialog.toast({ mes: "请勾选阅读并同意用户协议" });
        return;
      }
      login({
        username: username,
        password,
        userCategory: 2,
        spread: cookie.get("spread"),
      })
        .then(({ data }) => {
          this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
          this.$store.commit("SET_USER", data);
          const backUrl = "/user";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl });
        })
        .catch((e) => {
          this.$dialog.error(e.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.coach-login {
  padding: 0.77rem 0.64rem;
  background: #ffffff;
  position: relative;
  .register-title {
    font-size: 0.42rem;
    font-weight: 700;
  }
  .register-title-text {
    color: #999999;
    margin-top: 0.19rem;
  }
  .register-form {
    margin-top: 0.23rem;
  }
  .register-form-name {
    margin-bottom: 0.19rem;
    margin-top: 0.44rem;
  }
  .register-form-input {
    height: 0.78rem;
    padding: 0 0.23rem;
    background-color: #f8f8f8;
    border-radius: 2rem;
  }
  .text-num {
    color: #b9bde5;
  }
  .btn {
    display: block;
    color: #fff;
    width: 100%;
    height: 0.68rem;
    background: #0ce6df;
    line-height: 0.68rem;
    text-align: center;
    border-radius: 0.5rem;
  }
  .forget {
    margin-top: 0.4rem;
  }
  .bottom {
    // position: absolute;
    // bottom: 0.46rem;
    // left: 0;
    // right: 0;
    // padding: 0 0.77rem;
  }
  .padding-height {
    min-height: 1rem;
    height: calc(100vh - 9.5rem - 46px);
  }
}
.agree-content {
  width: 80vw;
  min-height: 20vh;
  max-height: 60vh;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0.3rem;
}
.agree-title {
  padding: 0.3rem;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}
.agree-btn {
  display: block;
  color: #fff;
  height: 0.68rem;
  background: #0ce6df;
  line-height: 0.68rem;
  text-align: center;
  border-radius: 0.5rem;
  margin: 0.3rem;
}
</style>
